import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const PRODUCT_TAGS = [
  { id: 1, name: "NEWSONY", color: "#8b5cf6", icon: "NS" },
  { id: 2, name: "PIX11981922", color: "#1890ff", icon: "PX" },
  { id: 3, name: "Sony Alpha", color: "#10b981", icon: "SA" },
  { id: 4, name: "Dell XPS", color: "#f59e0b", icon: "DX" }
];

const styles = `
  .event-calendar-container {
    display: grid;
    grid-template-columns: 300px 1fr;
    height: 100vh;
    background: #f8fafc;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }

  .ec-sidebar {
    background: white;
    border-right: 1px solid #e5e7eb;
    padding: 24px;
    overflow-y: auto;
  }

  .ec-sidebar-header h3 {
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 4px 0;
  }

  .ec-sidebar-header p {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 20px 0;
  }

  .ec-products-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .ec-product-tag {
    padding: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    cursor: grab;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .ec-product-tag:hover {
    border-color: #1890ff;
    background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  }

  .ec-product-tag:active {
    cursor: grabbing;
    transform: scale(0.98);
  }

  .ec-product-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 700;
    font-size: 14px;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  .ec-product-info {
    flex: 1;
  }

  .ec-product-name {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
  }

  .ec-product-meta {
    font-size: 12px;
    color: #64748b;
  }

  .ec-instructions {
    margin-top: 20px;
    padding: 16px;
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border: 1px solid #fbbf24;
    border-radius: 10px;
    font-size: 13px;
    color: #92400e;
  }

  .ec-instructions strong {
    display: block;
    margin-bottom: 8px;
    color: #78350f;
  }

  .ec-instructions ul {
    margin: 0;
    padding-left: 20px;
  }

  .ec-instructions li {
    margin-bottom: 4px;
  }

  .ec-calendar-wrapper {
    display: flex;
    flex-direction: column;
    background: #f8fafc;
  }

  .ec-calendar-header {
    background: white;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ec-calendar-header h2 {
    font-size: 22px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
  }

  .ec-stats {
    font-size: 14px;
    color: #64748b;
    font-weight: 600;
  }

  .ec-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: ec-fadeIn 0.2s;
  }

  @keyframes ec-fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .ec-modal {
    background: white;
    border-radius: 16px;
    width: 500px;
    max-width: 90vw;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: ec-slideUp 0.3s;
  }

  @keyframes ec-slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .ec-modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(to bottom, #fafafa, #f5f5f5);
  }

  .ec-modal-header h3 {
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
  }

  .ec-close-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    font-size: 28px;
    color: #64748b;
    cursor: pointer;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    padding: 0;
  }

  .ec-close-btn:hover {
    background: #f1f5f9;
    color: #1e293b;
  }

  .ec-modal-body {
    padding: 24px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .ec-form-group {
    margin-bottom: 20px;
  }

  .ec-form-group label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 8px;
  }

  .ec-form-group input,
  .ec-form-group textarea {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    color: #1e293b;
    transition: all 0.2s;
    box-sizing: border-box;
  }

  .ec-form-group input:focus,
  .ec-form-group textarea:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
  }

  .ec-readonly-field {
    padding: 10px 14px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    color: #64748b;
  }

  .ec-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #fafafa;
  }

  .ec-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
  }

  .ec-btn-secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e5e7eb;
  }

  .ec-btn-secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }

  .ec-btn-primary {
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  }

  .ec-btn-primary:hover:not(:disabled) {
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
    transform: translateY(-1px);
  }

  .ec-btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .rbc-calendar {
    padding: 16px;
  }

  .rbc-month-view {
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }

  .rbc-header {
    padding: 16px 12px;
    background: linear-gradient(to bottom, #fafafa, #f5f5f5);
    border-bottom: 2px solid #e5e7eb;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
  }

  .rbc-today {
    background: rgba(24, 144, 255, 0.05);
  }

  .rbc-addons-dnd .rbc-addons-dnd-over {
    background: rgba(24, 144, 255, 0.1) !important;
    border: 2px dashed #1890ff !important;
  }

  .rbc-event {
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    cursor: move;
  }
`;

const EventCalendar = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tempEvent, setTempEvent] = useState(null);
  const [formData, setFormData] = useState({
    quantity: "",
    notes: "",
    customer: ""
  });

  const onSelectSlot = ({ start, end, action }) => {
    if (action === "drop") {
      // This will be handled by handleDropFromOutside
      return;
    }
  };

  const handleDragStart = (product) => (e) => {
    e.dataTransfer.effectAllowed = "copy";
    e.dataTransfer.setData("product", JSON.stringify(product));
  };

  const customOnDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  };

  const moveEvent = ({ event, start, end }) => {
    const updatedEvents = events.map((ev) =>
      ev.id === event.id ? { ...ev, start, end } : ev
    );
    setEvents(updatedEvents);
  };

  const resizeEvent = ({ event, start, end }) => {
    const updatedEvents = events.map((ev) =>
      ev.id === event.id ? { ...ev, start, end } : ev
    );
    setEvents(updatedEvents);
  };

  const handleSaveEvent = () => {
    if (!tempEvent) return;

    const finalEvent = {
      ...tempEvent,
      ...formData,
      isTemp: false,
      title: `${tempEvent.title} - ${formData.customer || "No Customer"}`
    };

    setEvents([...events, finalEvent]);
    setShowModal(false);
    setTempEvent(null);
    setFormData({ quantity: "", notes: "", customer: "" });
  };

  const eventStyleGetter = (event) => {
    return {
      style: {
        backgroundColor: event.color || "#3174ad",
        borderRadius: "6px",
        opacity: event.isTemp ? 0.5 : 1,
        border: "1px solid rgba(255,255,255,0.3)",
        fontSize: "11px",
        fontWeight: 600
      }
    };
  };

  const handleSelectSlot = ({ start, end }) => {
    const productData = window.draggedProduct;
    if (!productData) return;

    const product = PRODUCT_TAGS.find((p) => p.id === productData.id);
    if (!product) return;

    const newEvent = {
      id: Date.now(),
      title: product.name,
      start: start,
      end: end,
      color: product.color,
      productId: product.id,
      isTemp: true
    };

    setTempEvent(newEvent);
    setShowModal(true);
    window.draggedProduct = null;
  };

  return (
    <>
      <style>{styles}</style>
      <div className="event-calendar-container">
        <div className="ec-sidebar">
          <div className="ec-sidebar-header">
            <h3>Available Products</h3>
            <p>Drag to calendar</p>
          </div>

          <div className="ec-products-list">
            {PRODUCT_TAGS.map((product) => (
              <div
                key={product.id}
                className="ec-product-tag"
                draggable
                onDragStart={(e) => {
                  handleDragStart(product)(e);
                  window.draggedProduct = product;
                }}
                style={{ borderLeft: `4px solid ${product.color}` }}
              >
                <div
                  className="ec-product-icon"
                  style={{ background: product.color }}
                >
                  {product.icon}
                </div>
                <div className="ec-product-info">
                  <div className="ec-product-name">{product.name}</div>
                  <div className="ec-product-meta">ID: {product.id}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="ec-instructions">
            <strong>Instructions:</strong>
            <ul>
              <li>Drag products to calendar</li>
              <li>Fill in metadata form</li>
              <li>Move/resize events after creation</li>
            </ul>
          </div>
        </div>

        <div className="ec-calendar-wrapper">
          <div className="ec-calendar-header">
            <h2>Event Calendar</h2>
            <div className="ec-stats">{events.length} Events</div>
          </div>

          <DnDCalendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: "calc(100vh - 80px)" }}
            onEventDrop={moveEvent}
            onEventResize={resizeEvent}
            resizable
            selectable
            onSelectSlot={handleSelectSlot}
            draggableAccessor={() => true}
            eventPropGetter={eventStyleGetter}
            onDragOver={customOnDragOver}
          />
        </div>

        {showModal && (
          <div
            className="ec-modal-overlay"
            onClick={() => setShowModal(false)}
          >
            <div className="ec-modal" onClick={(e) => e.stopPropagation()}>
              <div className="ec-modal-header">
                <h3>Add Event Details</h3>
                <button
                  className="ec-close-btn"
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>

              <div className="ec-modal-body">
                <div className="ec-form-group">
                  <label>Product</label>
                  <div className="ec-readonly-field">{tempEvent?.title}</div>
                </div>

                <div className="ec-form-group">
                  <label>Date Range</label>
                  <div className="ec-readonly-field">
                    {tempEvent?.start.toLocaleDateString()} -{" "}
                    {tempEvent?.end.toLocaleDateString()}
                  </div>
                </div>

                <div className="ec-form-group">
                  <label>Customer Name *</label>
                  <input
                    type="text"
                    value={formData.customer}
                    onChange={(e) =>
                      setFormData({ ...formData, customer: e.target.value })
                    }
                    placeholder="Enter customer name"
                  />
                </div>

                <div className="ec-form-group">
                  <label>Quantity *</label>
                  <input
                    type="number"
                    value={formData.quantity}
                    onChange={(e) =>
                      setFormData({ ...formData, quantity: e.target.value })
                    }
                    placeholder="Enter quantity"
                  />
                </div>

                <div className="ec-form-group">
                  <label>Notes</label>
                  <textarea
                    value={formData.notes}
                    onChange={(e) =>
                      setFormData({ ...formData, notes: e.target.value })
                    }
                    placeholder="Additional notes..."
                    rows={3}
                  />
                </div>
              </div>

              <div className="ec-modal-footer">
                <button
                  className="ec-btn ec-btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="ec-btn ec-btn-primary"
                  onClick={handleSaveEvent}
                  disabled={!formData.customer || !formData.quantity}
                >
                  Save Event
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EventCalendar;
